export const replaceSpecialCharacters = (str: string) => {
    // Replace spaces and special characters with underscores using regex
    const replacedStr = str.replace(/[\s~`!@#$%^&*(){}\[\];:"'<,.>?\/\\|_+=-]/g, '_');
    return replacedStr.toLowerCase();
}

export const removeHTMLTags = (str: string): string => {
    return str.replace(/<\/?[^>]+(>|$)/g, "");
}